var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V12H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.586141 0.585811C0.961995 0.210833 1.47124 0.000244141 2.00216 0.000244141C2.53308 0.000244141 3.04232 0.210833 3.41818 0.585811L6.00607 3.17273L8.58712 0.585811C8.9631 0.21107 9.4723 0.000646707 10.0031 0.000646707C10.534 0.000646707 11.0432 0.21107 11.4192 0.585811C11.7941 0.961666 12.0047 1.4709 12.0047 2.00182C12.0047 2.53274 11.7941 3.042 11.4192 3.41785L8.82931 5.99988L11.4162 8.5868C11.791 8.96277 12.0014 9.47197 12.0014 10.0028C12.0014 10.5336 11.791 11.0428 11.4162 11.4188C11.0402 11.7936 10.531 12.004 10.0002 12.004C9.46936 12.004 8.96016 11.7936 8.58419 11.4188L6.0002 8.82898L3.41818 11.4159C3.04219 11.7906 2.533 12.0011 2.00216 12.0011C1.47132 12.0011 0.962121 11.7906 0.586141 11.4159C0.2114 11.0399 0.000976562 10.5307 0.000976562 9.99988C0.000976562 9.46904 0.2114 8.95984 0.586141 8.58386L3.17111 5.99988L0.586141 3.41198C0.212948 3.03637 0.00349085 2.52838 0.00349085 1.9989C0.00349085 1.46941 0.212948 0.961422 0.586141 0.585811Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.5abf39a74d28b6f600c1c139a298b3a9.svg";
export { ForwardRef as ReactComponent };